import { AbstractBuilder } from '@ftr/foundation'
import { CourtroomRealTimeSttConfiguration } from '@ftr/regional-api-contracts'

export class CourtroomRealTimeSttConfigurationBuilder extends AbstractBuilder<CourtroomRealTimeSttConfiguration> {
  constructor() {
    super({
      hasHardwareAttribution: false,
      isSttEnabled: false,
      sttMode: 'off',
    })
  }
}
